import React from "react"
import { Button } from "react-bootstrap"
import { useNavigate, useLocation } from "react-router-dom"

const BackButton = ({ variant = "link", className = "" }) => {
    const navigate = useNavigate()
    const location = useLocation()

    // Don't render if we're at the root path or there's no navigation state
    if (location.pathname === '/' || !window.history.state?.idx) {
        return null
    }

    return (
        <Button
            variant={variant}
            size="sm"
            className={`p-0 ${className}`}
            onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left me-2" />
            Επιστροφή
        </Button>
    )
}

export default BackButton 